import React from 'react'
import Mouse from '@material-ui/icons/MouseOutlined'
import {
  CodeHolder,
  Description,
  WidgetContainer,
  WidgetEnabledSwitch,
  WidgetHeader,
  WidgetHolder,
  WidgetTitle,
  HeaderIcon,
  HeaderLeft,
  HeaderRight,
  HeaderText,
  Preview,
  SubTitle,
  Title,
} from 'organization/Event/WidgetConfig/RedirectWidget'
import {ButtonStyles, ButtonTemplate, Widget} from 'Event/Widget/template'
import {onChangeCheckedHandler} from 'lib/dom'
import ButtonStylesConfig from 'organization/Event/WidgetConfig/ButtonStylesConfig'
import generateWidgetCode from 'organization/Event/WidgetConfig/generate-widget-code'
import TextField from 'lib/ui/TextField'
import CopyButton from 'organization/Event/WidgetConfig/CopyButton'

export default function ButtonWidget(props: {
  button: ButtonTemplate
  onChange: (updatedFields: Partial<ButtonTemplate>) => void
  widget: Widget
}) {
  const {button, onChange, widget} = props

  const setActive = (isActive: boolean) => {
    onChange({enabled: isActive})
  }

  return (
    <WidgetHolder>
      <WidgetHeader>
        <HeaderLeft>
          <HeaderIcon>
            <Mouse />
          </HeaderIcon>
          <HeaderText>
            <Title isActive={button.enabled}>Clickable Button / Text</Title>
            <Description isActive={button.enabled}>
              Redirects attendees to your event dashboard when button or text is
              clicked
            </Description>
          </HeaderText>
        </HeaderLeft>
        <HeaderRight>
          <WidgetEnabledSwitch
            checked={button.enabled}
            onChange={onChangeCheckedHandler(setActive)}
            aria-label="toggle visible widget button"
          />
        </HeaderRight>
      </WidgetHeader>

      <Config button={button} onChange={onChange} widget={widget} />
    </WidgetHolder>
  )
}

function Config(props: {
  button: ButtonTemplate
  onChange: (updatedFields: Partial<ButtonTemplate>) => void
  widget: Widget
}) {
  const {button, onChange, widget} = props

  const handleButtonChange = (updatedStyles: ButtonStyles) => {
    onChange({styles: updatedStyles})
  }

  const handleLabelChange = (value: string) => {
    onChange({label: value})
  }

  const generatedCode = generateWidgetCode('button', widget)

  if (!button.enabled) {
    return null
  }

  return (
    <>
      <Preview>
        <TextField
          label="Button Label"
          name="title"
          value={button.label}
          fullWidth
          variant="outlined"
          onChange={handleLabelChange}
        />

        <SubTitle>Preview</SubTitle>

        <ButtonStylesConfig
          styles={button.styles}
          onChange={handleButtonChange}
          widget={widget}
        />
      </Preview>
      <WidgetContainer>
        <WidgetTitle>
          <SubTitle>Widget Code</SubTitle>
          <CopyButton value={generatedCode} />
        </WidgetTitle>
        <CodeHolder>
          <code>{generatedCode}</code>
        </CodeHolder>
      </WidgetContainer>
    </>
  )
}
